<script>
import { defineComponent } from "vue";
const name = 'PdfCartaPropostaProdutoCard'

export default defineComponent({
  name,

  components: { }, 

  props: { 
    nomeProduto: {
      type: String,
      default: ""
    },
    codigoOrcamento: {
      type: String,
      default: ""
    },
    opcao: {
      type: String,
      default: ""
    },
    descricaoFrete:{
        type: String,
        default: ""
        
    }

  },

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { }, 

});
</script>

<template>
    <div class="produto-container">
      <!-- <img src="@/assets/imgs/icone_componente_orcamento.svg"> -->
      <section class="info-container">
        <p> Nome do Produto:&nbsp; <em>{{nomeProduto}}</em> </p>
        <p> Orçamento:&nbsp; <em>{{codigoOrcamento}}</em> </p>
        <p> Opção:&nbsp; <em>{{opcao ? opcao : 'Não cadastrado'}}</em> </p>
        <p> Frete:&nbsp; <em>{{descricaoFrete ? descricaoFrete : "-" }} </em> </p>
      </section>
    </div>
</template>


<style scoped>

p{
  font-size: 14px;
}
.info-container{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-content: flex-start;
  justify-content: center;
  gap: 8px;

}

.produto-container,.info-container{
  background-color: #f9f9f9;
}
.produto-container{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
  padding: 8px;
  height: 100%;
  border-radius: 8px;
  
}

img{
  height: 48px;
  width: auto;
}

em{
  color: #4f2c19 ;
  text-align: left;
  font-weight: 700;
  padding-bottom: 5px;
  letter-spacing: 1px;
  font-style: normal;
}

p{
  color: #888888;
  margin: 0;
  padding: 0;
  font-weight: 700;
}
</style>
